import { Text, VisibleIcon } from "@minervaproject/fds";

function PollVisibility({
  isStudentVisible,
  textKind,
}: {
  isStudentVisible: boolean;
  textKind?: string;
}) {
  return (
    <div className="flex items-center">
      <VisibleIcon color="var(--black-tint-70)" width={12} height={12} mr={1} />
      <Text kind={textKind || "body-xs"} color="blackTint40" mr={1}>
        {isStudentVisible
          ? "Responses viewable by everyone"
          : "Responses viewable by instructor only"}
      </Text>
    </div>
  );
}

export { PollVisibility };
